<template>
    <div
        :style="{background: document.data.banner_color}"
        class="sticky-wrapper banner"
    >
        <div class="sticky-wrapper__inner">
            <div class="container-left">
                <sticky
                    :document="document"
                    :model="model"
                />
                <div class="text-compliance">
                    {{ model.complianceExample }}
                </div>
            </div>


            <div
                :style="{background: document.data.banner_color}"
                class="container-right"
            >
                <div class="card-data">
                    <h1 class="title">{{ document.data.title }}</h1>
                    <div class="container preamble">
                        {{ $prismic.asText(document.data.summary) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sticky from './CardSticky.vue';
export default {
    components: {
        Sticky
    },
    props: {
        document: {
            type: Object,
            required: true,
            default: () => {}
        },
        model: {
            type: Object,
            required: true,
            default: () => {}
        }
    }
};
</script>

<style lang="scss" scoped>
.banner { margin-top: 60px; }

.sticky-wrapper {
    @include flex;
    background: $green;

    @include device(pad) {
        padding-top: 80px!important;
        padding-bottom: 80px!important;
    }

    .container-right {
        background: $green;
    }

    @media screen and (max-width: 1000px) {
        .container-left {
            display: block!important;
            order: 2;
            width: 100%;
            margin-top: 30px;
        }
        .text-compliance {
            color:white;
            opacity: 0.8;
        }
    }
    @media screen and (min-width: 1001px) {
        .container-left {
            .card-sticky, .text-compliance { display: none; }
        }
    }
}

.card-data {
    width: 100%;
    @include grid(1,20px);
    color: $white;
    // h1 { color: $green; }

    .stars {
        img {@include size(35px);}
    }

    .usp-box {
        background: #FFF8F0;
        margin-bottom: 0;

        // border-color: $green!important;
        // span {
        //     color: $green!important;
        // }
    }
}

.data-boxes {
    background: $white;
    @include border;
    @include spacing(padding,2,(top, bottom));
    @include spacing(padding,4,(left,right));
    @include border-radius(10px);

}
</style>
